"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toc = exports.title = exports.slug = exports.pageId = exports.navTitle = exports.name = exports.metaDescription = exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("@mdx-js/react");
/*@jsxRuntime automatic @jsxImportSource react*/
// translate-ignore

const pageId = exports.pageId = 51261306631;
const slug = exports.slug = 'guides/api/crm/associations/associations-v4';
// translate-ignore
const navTitle = exports.navTitle = 'Associations v4';
const title = exports.title = 'CRM API |  Associations v4';
const name = exports.name = 'vNext Docs DP - Associations v4';
const metaDescription = exports.metaDescription = 'The CRM Associations endpoints are used to manage associations between tickets, products, line items, and their related contacts, companies, and deals.';
const toc = exports.toc = [{
  "depth": 0,
  "id": "associate-records",
  "label": "Associate records",
  "parent": null
}, {
  "depth": 1,
  "id": "associate-records-without-a-label",
  "label": "Associate records without a label",
  "parent": "associate-records"
}, {
  "depth": 1,
  "id": "associate-records-with-a-label",
  "label": "Associate records with a label",
  "parent": "associate-records"
}, {
  "depth": 0,
  "id": "retrieve-associated-records",
  "label": "Retrieve associated records",
  "parent": null
}, {
  "depth": 0,
  "id": "update-record-association-labels",
  "label": "Update record association labels",
  "parent": null
}, {
  "depth": 0,
  "id": "remove-record-associations",
  "label": "Remove record associations",
  "parent": null
}, {
  "depth": 0,
  "id": "report-on-high-association-usage",
  "label": "Report on high association usage",
  "parent": null
}, {
  "depth": 0,
  "id": "understand-association-definitions%2C-configurations%2C-and-labels",
  "label": "Understand association definitions, configurations, and labels",
  "parent": null
}, {
  "depth": 1,
  "id": "hubspot-defined-associations",
  "label": "HubSpot defined associations",
  "parent": "understand-association-definitions%2C-configurations%2C-and-labels"
}, {
  "depth": 1,
  "id": "custom-association-labels",
  "label": "Custom association labels",
  "parent": "understand-association-definitions%2C-configurations%2C-and-labels"
}, {
  "depth": 0,
  "id": "create-and-manage-association-types",
  "label": "Create and manage association types",
  "parent": null
}, {
  "depth": 1,
  "id": "create-association-labels",
  "label": "Create association labels",
  "parent": "create-and-manage-association-types"
}, {
  "depth": 1,
  "id": "retrieve-association-labels",
  "label": "Retrieve association labels",
  "parent": "create-and-manage-association-types"
}, {
  "depth": 1,
  "id": "update-association-labels",
  "label": "Update association labels",
  "parent": "create-and-manage-association-types"
}, {
  "depth": 1,
  "id": "delete-association-labels",
  "label": "Delete association labels",
  "parent": "create-and-manage-association-types"
}, {
  "depth": 0,
  "id": "set-and-manage-association-limits",
  "label": "Set and manage association limits",
  "parent": null
}, {
  "depth": 1,
  "id": "create-or-update-association-limits",
  "label": "Create or update association limits",
  "parent": "set-and-manage-association-limits"
}, {
  "depth": 1,
  "id": "retrieve-association-limits",
  "label": "Retrieve association limits",
  "parent": "set-and-manage-association-limits"
}, {
  "depth": 1,
  "id": "delete-association-limits",
  "label": "Delete association limits",
  "parent": "set-and-manage-association-limits"
}, {
  "depth": 0,
  "id": "limitations",
  "label": "Limitations",
  "parent": null
}, {
  "depth": 0,
  "id": "association-type-id-values",
  "label": "Association type ID values",
  "parent": null
}, {
  "depth": 1,
  "id": "company-to-object",
  "label": "Company to object",
  "parent": "association-type-id-values"
}, {
  "depth": 1,
  "id": "contact-to-object",
  "label": "Contact to object",
  "parent": "association-type-id-values"
}, {
  "depth": 1,
  "id": "deal-to-object",
  "label": "Deal to object",
  "parent": "association-type-id-values"
}, {
  "depth": 1,
  "id": "ticket-to-object",
  "label": "Ticket to object",
  "parent": "association-type-id-values"
}, {
  "depth": 1,
  "id": "lead-to-object",
  "label": "Lead to object",
  "parent": "association-type-id-values"
}, {
  "depth": 1,
  "id": "appointment-to-object",
  "label": "Appointment to object",
  "parent": "association-type-id-values"
}, {
  "depth": 1,
  "id": "course-to-object",
  "label": "Course to object",
  "parent": "association-type-id-values"
}, {
  "depth": 1,
  "id": "listing-to-object",
  "label": "Listing to object",
  "parent": "association-type-id-values"
}, {
  "depth": 1,
  "id": "service-to-object",
  "label": "Service to object",
  "parent": "association-type-id-values"
}, {
  "depth": 1,
  "id": "call-to-object",
  "label": "Call to object",
  "parent": "association-type-id-values"
}, {
  "depth": 1,
  "id": "email-to-object",
  "label": "Email to object",
  "parent": "association-type-id-values"
}, {
  "depth": 1,
  "id": "meeting-to-object",
  "label": "Meeting to object",
  "parent": "association-type-id-values"
}, {
  "depth": 1,
  "id": "note-to-object",
  "label": "Note to object",
  "parent": "association-type-id-values"
}, {
  "depth": 1,
  "id": "postal-mail-to-object",
  "label": "Postal mail to object",
  "parent": "association-type-id-values"
}, {
  "depth": 1,
  "id": "task-to-object",
  "label": "Task to object",
  "parent": "association-type-id-values"
}, {
  "depth": 1,
  "id": "communication-sms%2C-whatsapp%2C-or-linkedin-message-to-object",
  "label": "Communication (SMS, WhatsApp, or LinkedIn message) to object",
  "parent": "association-type-id-values"
}, {
  "depth": 1,
  "id": "invoice-to-object",
  "label": "Invoice to object",
  "parent": "association-type-id-values"
}, {
  "depth": 1,
  "id": "payment-to-object",
  "label": "Payment to object",
  "parent": "association-type-id-values"
}, {
  "depth": 1,
  "id": "quote-to-object",
  "label": "Quote to object",
  "parent": "association-type-id-values"
}, {
  "depth": 1,
  "id": "line-item-to-object",
  "label": "Line item to object",
  "parent": "association-type-id-values"
}, {
  "depth": 1,
  "id": "order-to-object",
  "label": "Order to object",
  "parent": "association-type-id-values"
}, {
  "depth": 1,
  "id": "cart-to-object",
  "label": "Cart to object",
  "parent": "association-type-id-values"
}, {
  "depth": 0,
  "id": "v1-associations-legacy",
  "label": "v1 associations (legacy)",
  "parent": null
}];
function _createMdxContent(props) {
  const _components = Object.assign({
      h1: "h1",
      p: "p",
      a: "a",
      ul: "ul",
      li: "li",
      strong: "strong",
      h2: "h2",
      em: "em",
      h3: "h3",
      code: "code",
      pre: "pre",
      table: "table",
      thead: "thead",
      tr: "tr",
      th: "th",
      tbody: "tbody",
      td: "td"
    }, (0, _react.useMDXComponents)(), props.components),
    {
      RelatedApiLink,
      Alert,
      DndSection
    } = _components;
  if (!Alert) _missingMdxReference("Alert", true);
  if (!DndSection) _missingMdxReference("DndSection", true);
  if (!RelatedApiLink) _missingMdxReference("RelatedApiLink", true);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_components.h1, {
      children: "Associations v4"
    }), "\n", (0, _jsxRuntime.jsx)(RelatedApiLink, {
      overrideHref: "/reference/api/crm/associations/association-details"
    }), "\n", (0, _jsxRuntime.jsx)(Alert, {
      type: "warning",
      children: (0, _jsxRuntime.jsxs)(_components.p, {
        children: ["For the previous version, please see the documentation for the ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "/guides/api/crm/associations/associations-v3",
          children: "v3 Associations API"
        }), "."]
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "Associations represent the relationships between objects and activities in the HubSpot CRM. Record associations can exist between records of different objects (e.g., Contact to Company), as well as within the same object (e.g., Company to Company)."
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "The v4 Associations API includes two sets of endpoints:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: (0, _jsxRuntime.jsx)(_components.a, {
            href: "/reference/api/crm/associations/association-details",
            children: "Association details endpoints"
          })
        }), ": create, edit, and remove associations between records."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: (0, _jsxRuntime.jsx)(_components.a, {
            href: "/reference/api/crm/associations/associations-schema",
            children: "Association schema endpoints"
          })
        }), ": view your account's association definitions (also known as types), create and manage custom association labels, and set limits for associations. Association labels are supported between contacts, companies, deals, tickets, and custom objects, and can be ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://knowledge.hubspot.com/object-settings/create-and-use-association-labels#use-association-labels-in-hubspot-tools",
          children: "used across HubSpot in tools"
        }), ", such as lists and workflows."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Learn more about objects, records, properties, and associations APIs in the ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/api/crm/understanding-the-crm",
        children: "Understanding the CRM"
      }), " guide."]
    }), "\n", (0, _jsxRuntime.jsx)(Alert, {
      type: "info",
      titleText: "Please note:",
      children: (0, _jsxRuntime.jsx)(_components.p, {
        children: "The v4 Associations API is supported in Version 9.0.0 or later of the NodeJS HubSpot Client."
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Associate records"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To associate records with records with one another, use the ", (0, _jsxRuntime.jsx)(_components.em, {
        children: "Association"
      }), " endpoints."]
    }), "\n", (0, _jsxRuntime.jsx)(Alert, {
      type: "warning",
      titleText: "Please note:",
      children: (0, _jsxRuntime.jsxs)(_components.p, {
        children: ["The number of associations a record can have depends on ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://legal.hubspot.com/hubspot-product-and-services-catalog#TechnicalLimits:~:text=CRM%20Record%20Association%20Limits",
          children: "the object and your HubSpot subscription."
        })]
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Associate records without a label"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["You can create a default unlabeled association between two records, or set up unlabeled associations for records in bulk. To set up an individual default association between two records, make a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "PUT"
      }), " request to"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        children: "/crm/v4/objects/{fromObjectType}/{fromObjectId}/associations/default/{toObjectType}/{toObjectId}"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "In the request URL, include:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "fromObjectType"
        }), (0, _jsxRuntime.jsx)(_components.strong, {
          children: ":"
        }), " the ID of the object you're associating. To find the ID values, refer to this ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "guides/api/crm/understanding-the-crm#object-type-ids",
          children: "list of object type IDs,"
        }), " or for contacts, companies, deals, tickets, and notes, you can use the object name (e.g., ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "contact"
        }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "company"
        }), ")."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "fromObjectId"
        }), (0, _jsxRuntime.jsx)(_components.strong, {
          children: ":"
        }), " the ID of the record to associate."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "toObjectType"
        }), (0, _jsxRuntime.jsx)(_components.strong, {
          children: ":"
        }), " the ID of the object you're associating the record to. To find the ID values, refer to this ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "guides/api/crm/understanding-the-crm#object-type-ids",
          children: "list of object type IDs,"
        }), " or for contacts, companies, deals, tickets, and notes, you can use the object name (e.g., ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "contact"
        }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "company"
        }), ")."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "toObjectId"
        }), (0, _jsxRuntime.jsx)(_components.strong, {
          children: ":"
        }), " the ID of the record to associate to."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["For example, to associate a contact record whose ID is 12345 with a company record whose ID is ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "67891"
      }), ", your request URL would be: ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "/crm/v4/objects/contact/12345/associations/default/company/67891"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To associate records without a label in bulk, make a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "POST"
      }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "crm/v4/associations/{fromObjectType}/{toObjectType}/batch/associate/default"
      }), ". In the request body, include ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "objectId"
      }), " values for the records you want to associate."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Associate records with a label"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "You can also associate records with labels for individual record pairs or multiple pairs of records in bulk."
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["To associate two records and set a label to describe the association, make a ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "PUT"
        }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "/crm/v4/objects/{objectType}/{objectId}/associations/{toObjectType}/{toObjectId}"
        }), ". In the request URL, include the ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "id"
        }), " values of the two records you're associating."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["To bulk create labelled associations between records of the same objects, make a ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "POST"
        }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "/crm/v4/associations/{fromObjectType}/{toObjectType}/batch/create"
        }), ". In the request body, include the ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "id"
        }), " values of records to associate in addition to the required parameters below."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "In the request body, include the following information to indicate the labeled association you want to create:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "associationCategory"
        }), ": either ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "HUBSPOT_DEFINED"
        }), " (default label) or ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "USER_DEFINED"
        }), " (custom label)."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "associationTypeId"
        }), ": the numerical ID value for the label. If using a default label (e.g., Primary company), refer to this ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "#association-type-id-values",
          children: "list of default type IDs."
        }), " If you're using a custom label, you'll need to ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "#retrieve-association-labels",
          children: "retrieve the labels"
        }), " between those objects."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["For each association, depending on your ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "#set-and-manage-association-limits",
        children: "association limits"
      }), ", you can include multiple labels."]
    }), "\n", (0, _jsxRuntime.jsx)(Alert, {
      type: "warning",
      titleText: "Please note:",
      children: (0, _jsxRuntime.jsxs)(_components.p, {
        children: ["For cross-object and paired label relationships, ensure you use the ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "typeId"
        }), " that refers to the correct direction (e.g., Contact to Company vs. Company to Contact, Employee to Manager vs. Manager to Employee)."]
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "For example, to associate a contact with a deal using a custom label:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["1. Make a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "GET"
      }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "/crm/v4/associations/contact/deal/labels"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["2. In the response, look at the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "typeId"
      }), " and ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "category"
      }), " values for the label. The ID will be a number (e.g., ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "36"
      }), "), and the category will always be ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "USER_DEFINED"
      }), " for custom labels."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["3. Make a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "PUT"
      }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "/crm/v4/objects/contact/{objectId}/associations/deal/{toObjectId}"
      }), "with the following example request body:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "[\n  {\n    \"associationCategory\": \"USER_DEFINED\",\n    \"associationTypeId\": 36\n  }\n]\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["A successful response will include the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "id"
      }), " values of the two associated records along with the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "label"
      }), " for the association. For the example above, the response would look like:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "{\n  \"fromObjectTypeId\": \"0-1\",\n  \"fromObjectId\": 29851,\n  \"toObjectTypeId\": \"0-3\",\n  \"toObjectId\": 21678228008,\n  \"labels\": [\"Point of contact\"]\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Retrieve associated records"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "You can retrieve a record's associations of a specific object."
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["To retrieve an individual record's associations of a specific object, make a ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "GET"
        }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "/crm/v4/objects/{fromObjectType}/{objectId}/associations/{toObjectType}"
        }), ". In the request URL, include the record's object as the ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "fromObjectType"
        }), " and its record ID as the ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "objectId"
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["To retrieve a record's associated records of a specific object, make a ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "POST"
        }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "/crm/v4/associations/{fromObjectType}/{toObjectType}/batch/read"
        }), ". In the request body, include up to 1,000 ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "id"
        }), " values of records whose associated records you want to retrieve."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["For example, to retrieve all company associations for two contacts, make a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "POST"
      }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "/crm/v4/associations/contacts/companies/batch/read"
      }), ". Your request would look like the following:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "/// Example request\n{\n  \"inputs\": [\n    {\n      \"id\": \"33451\"\n    },\n    {\n      \"id\": \"29851\"\n    }\n  ]\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["For both the basic and batch endpoints, the record ID values will be returned for each associated record, along with information to describe the association between the record, including the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "label"
      }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "category"
      }), ", and ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "typeId"
      }), ". For the example batch request above, the response would be:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "/// Example response\n{\n  \"status\": \"COMPLETE\",\n  \"results\": [\n    {\n      \"from\": {\n        \"id\": \"33451\"\n      },\n      \"to\": [\n        {\n          \"toObjectId\": 5790939450,\n          \"associationTypes\": [\n            {\n              \"category\": \"HUBSPOT_DEFINED\",\n              \"typeId\": 1,\n              \"label\": \"Primary\"\n            },\n            {\n              \"category\": \"HUBSPOT_DEFINED\",\n              \"typeId\": 279,\n              \"label\": null\n            },\n            {\n              \"category\": \"USER_DEFINED\",\n              \"typeId\": 28,\n              \"label\": \"Billing contact\"\n            }\n          ]\n        }\n      ]\n    },\n    {\n      \"from\": {\n        \"id\": \"29851\"\n      },\n      \"to\": [\n        {\n          \"toObjectId\": 5790939450,\n          \"associationTypes\": [\n            {\n              \"category\": \"HUBSPOT_DEFINED\",\n              \"typeId\": 1,\n              \"label\": \"Primary\"\n            },\n            {\n              \"category\": \"USER_DEFINED\",\n              \"typeId\": 37,\n              \"label\": \"Chef\"\n            },\n            {\n              \"category\": \"HUBSPOT_DEFINED\",\n              \"typeId\": 279,\n              \"label\": null\n            }\n          ]\n        },\n        {\n          \"toObjectId\": 6675245424,\n          \"associationTypes\": [\n            {\n              \"category\": \"HUBSPOT_DEFINED\",\n              \"typeId\": 279,\n              \"label\": null\n            }\n          ]\n        },\n        {\n          \"toObjectId\": 17705714757,\n          \"associationTypes\": [\n            {\n              \"category\": \"HUBSPOT_DEFINED\",\n              \"typeId\": 279,\n              \"label\": null\n            },\n            {\n              \"category\": \"USER_DEFINED\",\n              \"typeId\": 30,\n              \"label\": \"Decision maker\"\n            }\n          ]\n        }\n      ]\n    }\n  ],\n  \"startedAt\": \"2024-10-21T20:22:42.152Z\",\n  \"completedAt\": \"2024-10-21T20:22:42.167Z\"\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Update record association labels"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["For existing associations, to update the association labels, you can use the basic and batch create endpoints. If an existing labeled association exists between two records, to ", (0, _jsxRuntime.jsx)("u", {
        children: "replace"
      }), " the existing label, only include the new label in the request. If you want to append labels (i.e. add a new label and keep the existing label), include both labels in your request."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["For example, if records are already associated with a label with the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "typeId"
      }), " of ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "30"
      }), ", to keep that label while adding another label, your request would look like:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "/// Example request body\n[\n  {\n    \"associationCategory\": \"USER_DEFINED\",\n    \"associationTypeId\": 30\n  },\n  {\n    \"associationCategory\": \"USER_DEFINED\",\n    \"associationTypeId\": 37\n  }\n]\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Remove record associations"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["You can delete all associations between records, or delete only associations of specific types (i.e. default or custom labels). When deleting all associations, the records will ", (0, _jsxRuntime.jsx)("u", {
        children: "not"
      }), " be deleted, but they will no longer be associated with one another. If deleting a specific association type, the records will still be associated but the specified labels will be removed, with the exception of deleting the default unlabelled association type which will remove all other associations."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "To remove all associations:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["To remove all associations between two records, make a ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "DELETE"
        }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "/crm/v4/objects/{objectType}/{objectId}/associations/{toObjectType}/{toObjectId}"
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["To batch remove all associations between records, make a ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "POST"
        }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "/crm/v4/associations/{fromObjectType}/{toObjectType}/batch/archive"
        }), ". In the request body, include the ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "id"
        }), " values of records for which you want to remove all of their associations."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "For example, to remove all associations between sets of contacts and companies, your request would look like:"
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "/// Example request body POST crm/v4/associations/contacts/companies/batch/archive\n[\n    {\n      \"from\": {\n        \"id\": \"12345\"\n      },\n      \"to\": [\n        {\n          \"id\": \"67891\"\n        }\n      ]\n    },\n    {\n      \"from\": {\n        \"id\": \"9876\"\n      },\n      \"to\": [\n        {\n          \"id\": \"54321\"\n        }\n      ]\n    }\n  ]\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To remove specific association labels, make a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "POST"
      }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "/crm/v4/associations/{fromObjectType}/{toObjectType}/batch/labels/archive"
      }), ". In the request body, include an array with ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "id"
      }), " values of the associated records and the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "associationTypeId"
      }), " and ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "category"
      }), " values of label(s) to remove."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "For example, to remove a custom label from an association, but keep the unlabeled association, your request would look like:"
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "/// Example request body POST crm/v4/associations/contacts/companies/batch/labels/archive\n{\n  \"inputs\": [\n    {\n      \"types\": [\n        {\n          \"associationCategory\": \"USER_DEFINED\",\n          \"associationTypeId\": 37\n        }\n      ],\n      \"from\": {\n        \"id\": \"29851\"\n      },\n      \"to\": {\n        \"id\": \"5790939450\"\n      }\n    }\n  ]\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "If you then retrieve that contact's company associations, now only the unlabelled association type will be returned for the above associated company:"
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "/// Example response GET crm/v4/objects/contacts/29851/associations/companies\n{\n  \"results\": [\n    {\n      \"toObjectId\": 5790939450,\n      \"associationTypes\": [\n        {\n          \"category\": \"HUBSPOT_DEFINED\",\n          \"typeId\": 279,\n          \"label\": null\n        }\n      ]\n    },\n    {\n      \"toObjectId\": 6675245424,\n      \"associationTypes\": [\n        {\n          \"category\": \"HUBSPOT_DEFINED\",\n          \"typeId\": 279,\n          \"label\": null\n        }\n      ]\n    },\n    {\n      \"toObjectId\": 17705714757,\n      \"associationTypes\": [\n        {\n          \"category\": \"HUBSPOT_DEFINED\",\n          \"typeId\": 279,\n          \"label\": null\n        },\n        {\n          \"category\": \"USER_DEFINED\",\n          \"typeId\": 30,\n          \"label\": \"Decision maker\"\n        }\n      ]\n    }\n  ]\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Report on high association usage"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["There are technical ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://legal.hubspot.com/hubspot-product-and-services-catalog",
        children: "limits to the number of associations a record can have"
      }), ". You can use the associations API to retrieve a report of records that are either approaching or have hit the maximum limit for associations."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To retrieve the report, make a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "POST"
      }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "crm/v4/associations/usage/high-usage-report/{userID}"
      }), ". The file includes records using 80% or more of their association limit. For example, if a company can be associated with up to 50,000 contacts, the company will be included in the file if it has 40,000 or more associated contacts. The file will be sent to the email of the user whose ID was included in the request URL. Learn how to retrieve user IDs with the ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/api/settings/users/user-provisioning",
        children: "users API"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Understand association definitions, configurations, and labels"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To manage association definition (a.k.a association type) configurations and labels, use the ", (0, _jsxRuntime.jsx)(_components.em, {
        children: "Association schema"
      }), " endpoints. These endpoints include configuration endpoints and label endpoints. You should use the endpoints for the following goals:"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: "Association definitions (labels)"
        }), ": create and manage association types, including creating, editing, and deleting custom association labels. For example, create a ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Billing contact"
        }), " label between contacts and deals or a ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Manager"
        }), " and ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Employee"
        }), " paired label between contacts."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: "Association definition configurations"
        }), ": set and manage limits for how many associations can exist per association type. For example, allow up to five associated deals per company or only one associated contact with the ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Decision maker"
        }), " label per company."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "HubSpot defined associations"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["HubSpot provides a set of predefined association types (e.g., unlabeled contact to company), but account admins can ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://knowledge.hubspot.com/object-settings/create-and-use-association-labels",
        children: "define their own association labels"
      }), " to provide additional context for record relationships (e.g., manager and employee). There are two HubSpot-defined association types:"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: "Primary:"
        }), " the main company that the other record is associated with. Primary associations can be used in HubSpot tools such as ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://knowledge.hubspot.com/object-settings/create-and-use-association-labels#use-associations-in-hubspot-tools",
          children: "lists and workflows"
        }), ". For records with multiple associated companies, this API supports changing which company is considered the primary."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: "Unlabeled:"
        }), " an association added when any contact, company, deal, ticket, or custom object record is associated. This type denotes that an association exists, and will always ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "#retrieve-associated-records",
          children: "returned"
        }), " in responses with a ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "label"
        }), " value of ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "null"
        }), ". When a record has a primary association or a custom association label, those types will be ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "#retrieve-associated-records",
          children: "listed alongside the unlabeled association type"
        }), "."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["You can view all of the HubSpot-defined association types in ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "#association-type-id-values",
        children: "this section"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Custom association labels"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["You can create association labels to further define record associations. For example, you could create a ", (0, _jsxRuntime.jsx)(_components.em, {
        children: "Decision maker"
      }), " label to indicate which contacts at a company are responsible for making purchasing decisions."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Learn more about ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "#create-association-labels",
        children: "creating association labels below"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Create and manage association types"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "Use the definitions endpoints to create custom labeled association types and review or manage existing types."
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Create association labels"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["You can create custom labeled association types ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://knowledge.hubspot.com/object-settings/create-and-use-association-labels",
        children: "in HubSpot"
      }), " or through the association schema API endpoint. You can create up to 10 association labels between each object pairing (e.g. contacts and companies, contacts and contacts)."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["There are two types of ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://knowledge.hubspot.com/object-settings/create-and-use-association-labels",
        children: "association labels"
      }), " you can use to describe the relationships between records:"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: "Single:"
        }), " one label that applies to both records in the relationship. For example, ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Friend"
        }), " or ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Colleague"
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: "Paired"
        }), ": a pair of labels for when different words are used to describe each side of the associated records' relationship. For example, ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Parent"
        }), " and ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Child"
        }), " or ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Employer"
        }), " and ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Employee"
        }), ". To create paired labels, you must include the ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "inverseLabel"
        }), " field in your request to name the second label in the pair."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To create a labeled association type, make a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "POST"
      }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "/crm/v4/associations/{fromObjectType}/{toObjectType}/labels"
      }), " and include the following in your request:"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: "name"
        }), ": the internal name of the association type. This value ", (0, _jsxRuntime.jsx)("u", {
          children: "cannot"
        }), " include hyphens or begin with a numerical character."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: "label"
        }), ": the name of the ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://knowledge.hubspot.com/object-settings/create-and-use-association-labels",
          children: "association label as shown in HubSpot"
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: "inverseLabel"
        }), " (paired labels only): the name of the second label in the pair of labels."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "For example, your request could look similar to the following:"
    }), "\n", (0, _jsxRuntime.jsxs)(DndSection, {
      children: [(0, _jsxRuntime.jsx)(_components.pre, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          className: "language-json",
          children: "///Example request body - Single label\n{\n  \"label\": \"Partner\",\n  \"name\": \"partner\"\n}\n"
        })
      }), (0, _jsxRuntime.jsx)(_components.pre, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          className: "language-json",
          children: "///Example request body - Paired labels\n{\n  \"label\": \"Manager\",\n  \"inverseLabel\": \"Employee\",\n  \"name\": \"manager_employee\"\n}\n"
        })
      })]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["In the response, the new association label's ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "category"
      }), " and unique ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "typeId"
      }), " will be returned, which you can use to retrieve, update, or delete the label moving forward. For paired labels, there'll be a value for each direction of the association (e.g., ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "550"
      }), " for contact to company and ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "551"
      }), " for company to contact). For example, for the paired label request above, the response would look like:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "///Example response\n{\n  \"results\": [\n    {\n      \"category\": \"USER_DEFINED\",\n      \"typeId\": 145,\n      \"label\": \"Employee\"\n    },\n    {\n      \"category\": \"USER_DEFINED\",\n      \"typeId\": 144,\n      \"label\": \"Manager\"\n    }\n  ]\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Once created, you can now add the label when ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "#associate-records-with-a-label",
        children: "associating records"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Retrieve association labels"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To view the association types between specific objects, make a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "GET"
      }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "/crm/v4/associations/{fromObjectType}/{toObjectType}/labels"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "You'll receive an array, each item containing:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "category"
        }), (0, _jsxRuntime.jsx)(_components.strong, {
          children: ":"
        }), " whether the association type was created by HubSpot (", (0, _jsxRuntime.jsx)(_components.code, {
          children: "HUBSPOT_DEFINED"
        }), ") or by a user (", (0, _jsxRuntime.jsx)(_components.code, {
          children: "USER_DEFINED"
        }), ")."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "typeId"
        }), (0, _jsxRuntime.jsx)(_components.strong, {
          children: ":"
        }), " the numeric ID for that association type. This is used to ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "#associate-records-with-a-label",
          children: "set a label when associating records"
        }), ". Refer to ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "#association-type-id-values",
          children: "this list"
        }), " for all the HubSpot defined ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "typeId"
        }), " values."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "label"
        }), (0, _jsxRuntime.jsx)(_components.strong, {
          children: ":"
        }), " the alphanumeric label. This will be ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "null"
        }), " for the unlabeled association type."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["You can also find these values in HubSpot ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://knowledge.hubspot.com/object-settings/create-and-use-association-labels#association-label-api-details",
        children: "in your association settings"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["For example, to view all association types from contacts to companies, make a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "GET"
      }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "/crm/v4/associations/contacts/companies/labels"
      }), ". Your response would look similar to the following:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "///Example response\n{\n  \"results\": [\n    {\n      \"category\": \"HUBSPOT_DEFINED\",\n      \"typeId\": 1,\n      \"label\": \"Primary\"\n    },\n    {\n      \"category\": \"USER_DEFINED\",\n      \"typeId\": 28,\n      \"label\": \"Billing contact\"\n    },\n    {\n      \"category\": \"USER_DEFINED\",\n      \"typeId\": 142,\n      \"label\": \"Toy Tester\"\n    },\n    {\n      \"category\": \"USER_DEFINED\",\n      \"typeId\": 26,\n      \"label\": \"Manager\"\n    },\n    {\n      \"category\": \"USER_DEFINED\",\n      \"typeId\": 30,\n      \"label\": \"Decision maker\"\n    },\n    {\n      \"category\": \"USER_DEFINED\",\n      \"typeId\": 37,\n      \"label\": \"Chef\"\n    },\n    {\n      \"category\": \"USER_DEFINED\",\n      \"typeId\": 32,\n      \"label\": \"Contractor\"\n    },\n    {\n      \"category\": \"HUBSPOT_DEFINED\",\n      \"typeId\": 279,\n      \"label\": null\n    }\n  ]\n}\n  ]\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Update association labels"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["You can edit the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "label"
      }), " field for association types, which updates the name as it appears in HubSpot in your settings and on records. You ", (0, _jsxRuntime.jsx)("u", {
        children: "cannot"
      }), " change the internal ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "name"
      }), " or ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "typeId"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To update a label, make a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "PUT"
      }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "/crm/v4/associations/{fromObjectType}/{toObjectType}/labels"
      }), ". In the request body, including the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "associationTypeId"
      }), " and a new value for ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "label"
      }), ". If editing a paired label, you can also include a new value for ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "inverseLabel"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Using the example in the section above, to update the label ", (0, _jsxRuntime.jsx)(_components.em, {
        children: "Contractor"
      }), " to ", (0, _jsxRuntime.jsx)(_components.em, {
        children: "Contract worker"
      }), ", your request would look like:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "///Example request\n{\n  \"associationTypeId\": 32,\n  \"label\": \"Contract worker\"\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Delete association labels"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["You can delete custom association labels if they're no longer in use. If a label is used to describe associated records, you'll need to ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "#remove-record-associations",
        children: "remove the label"
      }), " from associations before deleting. Default association types, including the ", (0, _jsxRuntime.jsx)(_components.em, {
        children: "Primary company"
      }), " label, ", (0, _jsxRuntime.jsx)("u", {
        children: "cannot"
      }), " be deleted."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To delete an association label, make a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "DELETE"
      }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "/crm/v4/associations/{fromObjectType}/{toObjectType}/labels/{associationTypeId}"
      }), ". You'll no longer be able to use this label when associating records."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Set and manage association limits"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Use the definition configuration endpoints to set up ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://knowledge.hubspot.com/object-settings/set-limits-for-record-associations",
        children: "limits"
      }), " for the number of associated records between objects, or how often a label can be used to describe associations. There are also ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://legal.hubspot.com/hubspot-product-and-services-catalog",
        children: "technical limits and limits based on your HubSpot subscription"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Create or update association limits"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "You can create new or update existing association limits between objects."
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["To create limits, make a ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "POST"
        }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "crm/v4/associations/definitions/configurations/{fromObjectType}/{toObjectType}/batch/create"
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["To update existing limits, make a ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "POST"
        }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "crm/v4/associations/definitions/configurations/{fromObjectType}/{toObjectType}/batch/update"
        }), "."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["In the request body, include ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "inputs"
      }), " with the following:"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "Parameter"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Description"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "category"
            })
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: ["The category of the association you're setting a limit for, either ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "HUBSPOT_DEFINED"
            }), " or ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "USER_DEFINED"
            }), "."]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "typeId"
            })
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: ["The numeric ID for the association type you want to set a limit for. Refer to ", (0, _jsxRuntime.jsx)(_components.a, {
              href: "#association-type-id-values",
              children: "this list"
            }), " of default ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "typeId"
            }), " values or ", (0, _jsxRuntime.jsx)(_components.a, {
              href: "#retrieve-association-labels",
              children: "retrieve the value"
            }), " for custom labels."]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "maxToObjectIds"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "The maximum number of associations allowed for the association type."
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["For example, to set limits that a deal can be associated with a maximum of five contacts with only one contact labelled ", (0, _jsxRuntime.jsx)(_components.em, {
        children: "Point of contact"
      }), " for a deal, your request would look like the following:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "///Example request POST crm/v4/associations/definitions/configurations/deal/contact/batch/create\n{\n  \"inputs\": [\n    {\n      \"category\": \"HUBSPOT_DEFINED\",\n      \"typeId\": 3,\n      \"maxToObjectIds\": 5\n    },\n    {\n      \"category\": \"USER_DEFINED\",\n      \"typeId\": 35,\n      \"maxToObjectIds\": 1\n    }\n  ]\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Retrieve association limits"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["To read all defined association limits, make a ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "GET"
        }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "/crm/v4/associations/definitions/configurations/all"
        }), ". This will return custom association limits defined across all objects."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["To read association limits between two specific objects, make a ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "GET"
        }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "/crm/v4/associations/definitions/configurations/{fromObjectType}/{toObjectType}"
        }), "."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["For both requests, the response will return the associations' values for ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "category"
      }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "typeId"
      }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "maxToObjectIds"
      }), ", and ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "label"
      }), ". For example, if retrieving limits between deals and contacts, the response would look similar to:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "///Example response GET crm/v4/associations/definitions/configurations/deal/contact\n{\n  \"results\": [\n    {\n      \"category\": \"HUBSPOT_DEFINED\",\n      \"typeId\": 3,\n      \"userEnforcedMaxToObjectIds\": 5,\n      \"label\": null\n    }\n  ]\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Delete association limits"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To delete specific association limits, make a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "POST"
      }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "/crm/v4/associations/definitions/configurations/{fromObjectType}/{toObjectType}/batch/purge"
      }), ". In the request body, include the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "category"
      }), " and ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "typeId"
      }), " values of the association types for which you want to remove limits."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["For example, to remove the ", (0, _jsxRuntime.jsx)(_components.em, {
        children: "Point of contact"
      }), " limit between deals and contacts, the request would look like:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "///Example request POST crm/v4/associations/definitions/configurations/deal/contact/batch/purge\n{\n  \"inputs\": [\n    {\n      \"category\": \"USER_DEFINED\",\n      \"typeId\": 35\n    }\n  ]\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["If successful, you'll receive a 204 response and the included limit will return to the system default (i.e. Many contacts can have the label ", (0, _jsxRuntime.jsx)(_components.em, {
        children: "Point of contact"
      }), ")."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Limitations"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "The association API endpoints are subject to the following limits based on your account subscription:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Daily limits:", "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
          children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: [(0, _jsxRuntime.jsxs)(_components.strong, {
              children: [(0, _jsxRuntime.jsx)(_components.em, {
                children: "Professional"
              }), " accounts:"]
            }), " 500,000 requests"]
          }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: [(0, _jsxRuntime.jsxs)(_components.strong, {
              children: [(0, _jsxRuntime.jsx)(_components.em, {
                children: "Enterprise"
              }), " accounts:"]
            }), " 500,000 requests"]
          }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: ["You can purchase an ", (0, _jsxRuntime.jsx)(_components.a, {
              href: "https://legal.hubspot.com/hubspot-product-and-services-catalog#Addons",
              children: "API limit increase"
            }), ", you can make a maximum of 1,000,000 requests per day. This maximum will ", (0, _jsxRuntime.jsx)("u", {
              children: "not"
            }), " increase for association API requests if you purchase an additional API limit increase."]
          }), "\n"]
        }), "\n"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Burst limits:", "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
          children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: [(0, _jsxRuntime.jsx)(_components.strong, {
              children: (0, _jsxRuntime.jsx)(_components.em, {
                children: "Free"
              })
            }), " ", (0, _jsxRuntime.jsxs)(_components.strong, {
              children: ["and ", (0, _jsxRuntime.jsx)(_components.em, {
                children: "Starter"
              }), " accounts:"]
            }), " 100 requests per 10 seconds"]
          }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: [(0, _jsxRuntime.jsx)(_components.em, {
              children: (0, _jsxRuntime.jsx)(_components.strong, {
                children: "Professional"
              })
            }), " ", (0, _jsxRuntime.jsxs)(_components.strong, {
              children: ["and ", (0, _jsxRuntime.jsx)(_components.em, {
                children: "Enterprise"
              }), " accounts:"]
            }), " 150 requests per 10 seconds"]
          }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: ["If you purchase the ", (0, _jsxRuntime.jsx)(_components.a, {
              href: "https://legal.hubspot.com/hubspot-product-and-services-catalog#Addons",
              children: "API limit increase"
            }), ", you can make a maximum of 200 requests per 10 seconds. This maximum will ", (0, _jsxRuntime.jsx)("u", {
              children: "not"
            }), " increase for association API requests if you purchase an additional API limit increase."]
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Learn more about API limits in ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/apps/api-usage/usage-details",
        children: "this article"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Association type ID values"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["The following tables include the HubSpot-defined ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "associationTypeId"
      }), " values that specify the type of association. Association types vary depending on the included objects and the direction of the association (e.g., Contact to Company is different from Company to Contact). If you create custom objects or custom association labels, the related association types will have unique ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "typeId"
      }), " values that you'll need to ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "#retrieve-association-labels",
        children: "retrieve"
      }), " or locate in your ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://knowledge.hubspot.com/object-settings/create-and-use-association-labels#association-label-api-details",
        children: "association settings in HubSpot"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(Alert, {
      type: "warning",
      titleText: "Please note:",
      children: (0, _jsxRuntime.jsx)(_components.p, {
        children: "Default company association types include an unlabeled association type and a primary association type. If a record has more than one associated company, only one can be the primary company. The other associations can either be unlabelled or have custom association labels."
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Company to object"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "TYPE ID"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Association type"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "450"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to company"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "14"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Child to parent company"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "13"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Parent to child company"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "280"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to contact"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "2"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to contact (Primary)"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "342"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to deal"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "6"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to deal (Primary)"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "340"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to ticket"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "25"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to ticket (Primary)"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "181"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to call"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "185"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to email"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "187"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to meeting"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "189"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to note"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "191"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to task"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "88"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to communication (SMS, WhatsApp, or LinkedIn message)"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "460"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to postal mail"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "180"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to invoice"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "510"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to order"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "390"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to payment"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "298"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to subscription"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "909"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to appointment"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "939"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to course"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "885"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to listing"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "793"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to service"
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Contact to object"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "TYPE ID"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Association type"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "449"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact to contact"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "279"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact to company"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "1"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact to company (Primary)"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "4"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact to deal"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "15"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact to ticket"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "193"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact to call"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "197"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact to email"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "199"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact to meeting"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "201"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact to note"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "203"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact to task"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "82"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact to communication (SMS, WhatsApp, or LinkedIn message)"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "454"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact to postal mail"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "587"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact to cart"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "508"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact to order"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "178"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact to invoice"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "388"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact to payment"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "296"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact to subscription"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "907"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact to appointment"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "861"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact to course"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "883"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact to listing"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "799"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact to service"
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Deal to object"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "TYPE ID"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Association type"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "451"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to deal"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "3"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to contact"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "341"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to company"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "5"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to company (Primary)"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "27"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to ticket"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "205"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to call"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "209"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to email"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "211"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to meeting"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "213"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to note"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "215"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to task"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "86"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to communication (SMS, WhatsApp, or LinkedIn message)"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "458"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to postal mail"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "313"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to deal split"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "19"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to line item"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "176"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to invoice"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "511"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to order"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "392"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to payment"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "63"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to quote"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "300"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to subscription"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "945"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to appointment"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "863"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to course"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "887"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to listing"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "795"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to service"
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Ticket to object"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "TYPE ID"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Association type"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "452"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Ticket to ticket"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "16"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Ticket to contact"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "339"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Ticket to company"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "26"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Ticket to company (Primary)"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "28"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Ticket to deal"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "219"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Ticket to call"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "223"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Ticket to email"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "225"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Ticket to meeting"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "227"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Ticket to note"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "229"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Ticket to task"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "84"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Ticket to communication (SMS, WhatsApp, or LinkedIn message)"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "456"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Ticket to postal mail"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "32"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Ticket to thread"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "278"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Ticket to conversation"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "526"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Ticket to order"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "947"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Ticket to appointment"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "941"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Ticket to course"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "943"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Ticket to listing"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "797"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Ticket to service"
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Lead to object"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "TYPE ID"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Association type"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "578"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Lead to primary contact"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "608"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Lead to contact"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "610"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Lead to company"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "596"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Lead to call"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "598"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Lead to email"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "600"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Lead to meeting"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "854"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Lead to note"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "646"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Lead to task"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "602"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Lead to communication (SMS, WhatsApp, or LinkedIn message)"
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Appointment to object"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "TYPE ID"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Association type"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "906"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Appointment to contact"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "908"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Appointment to company"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "944"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Appointment to deal"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "946"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Appointment to ticket"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "912"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Appointment to call"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "916"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Appointment to email"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "918"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Appointment to meeting"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "920"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Appointment to note"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "922"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Appointment to task"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "924"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Appointment to communication (SMS, WhatsApp, or LinkedIn message)"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "926"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Appointment to postal mail"
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Course to object"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "TYPE ID"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Association type"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "860"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Course to contact"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "938"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Course to company"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "862"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Course to deal"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "940"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Course to ticket"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "866"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Course to call"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "870"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Course to email"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "872"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Course to meeting"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "874"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Course to note"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "876"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Course to task"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "878"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Course to communication (SMS, WhatsApp, or LinkedIn message)"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "880"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Course to postal mail"
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Listing to object"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "TYPE ID"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Association type"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "882"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Listing to contact"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "884"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Listing to company"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "886"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Listing to deal"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "942"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Listing to ticket"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "890"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Listing to call"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "894"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Listing to email"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "896"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Listing to meeting"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "898"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Listing to note"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "900"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Listing to task"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "902"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Listing to communication (SMS, WhatsApp, or LinkedIn message)"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "904"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Listing to postal mail"
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Service to object"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "TYPE ID"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Association type"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "798"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Service to contact"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "792"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Service to company"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "794"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Service to deal"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "796"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Service to ticket"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "840"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Service to call"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "842"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Service to email"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "838"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Service to meeting"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "836"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Service to note"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "852"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Service to task"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "846"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Service to communication (SMS, WhatsApp, or LinkedIn message)"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "848"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Service to postal mail"
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Call to object"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "TYPE ID"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Association type"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "194"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Call to contact"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "182"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Call to company"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "206"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Call to deal"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "220"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Call to ticket"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "913"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Call to appointment"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "867"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Call to course"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "891"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Call to listing"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "841"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Call to service"
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Email to object"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "TYPE ID"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Association type"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "198"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Email to contact"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "186"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Email to company"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "210"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Email to deal"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "224"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Email to ticket"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "917"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Email to appointment"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "871"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Email to course"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "895"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Email to listing"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "843"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Email to service"
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Meeting to object"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "TYPE ID"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Association type"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "200"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Meeting to contact"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "188"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Meeting to company"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "212"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Meeting to deal"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "226"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Meeting to ticket"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "919"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Meeting to appointment"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "873"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Meeting to course"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "897"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Meeting to listing"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "839"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Meeting to service"
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Note to object"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "TYPE ID"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Association type"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "202"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Note to contact"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "190"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Note to company"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "214"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Note to deal"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "228"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Note to ticket"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "921"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Note to appointment"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "875"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Note to course"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "899"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Note to listing"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "837"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Note to service"
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Postal mail to object"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "TYPE ID"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Association type"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "453"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Postal mail to contact"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "459"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Postal mail to company"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "457"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Postal mail to deal"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "455"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Postal mail to ticket"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "927"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Postal mail to appointment"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "881"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Postal mail to course"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "905"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Postal mail to listing"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "849"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Postal mail to service"
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Task to object"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "TYPE ID"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Association type"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "204"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Task to contact"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "192"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Task to company"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "216"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Task to deal"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "230"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Task to ticket"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "923"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Task to appointment"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "877"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Task to course"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "901"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Task to listing"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "853"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Task to service"
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Communication (SMS, WhatsApp, or LinkedIn message) to object"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "TYPE ID"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Association type"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "81"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Communication (SMS, WhatsApp, or LinkedIn Message) to contact"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "87"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Communication (SMS, WhatsApp, or LinkedIn Message) to company"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "85"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Communication (SMS, WhatsApp, or LinkedIn Message) to deal"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "83"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Communication (SMS, WhatsApp, or LinkedIn Message) to ticket"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "925"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Communication (SMS, WhatsApp, or LinkedIn Message) to appointment"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "879"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Communication (SMS, WhatsApp, or LinkedIn Message) to course"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "903"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Communication (SMS, WhatsApp, or LinkedIn Message) to listing"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "847"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Communication (SMS, WhatsApp, or LinkedIn Message) to service"
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Invoice to object"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "TYPE ID"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Association type"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "177"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Invoice to contact"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "179"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Invoice to company"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "175"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Invoice to deal"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "407"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Invoice to quote"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "622"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Invoice to subscription"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "815"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Invoice to payment link"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "517"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Invoice to order"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "986"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Invoice to ticket"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "409"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Invoice to line item"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "411"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Invoice to discount"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "413"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Invoice to fee"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "415"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Invoice to tax"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "541"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Invoice to commerce payment"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "691"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Invoice to payment schedule installment"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "679"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Invoice to data sync state"
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Payment to object"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "TYPE ID"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Association type"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "389"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Payment to company"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "387"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Payment to contact"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "391"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Payment to deal"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "428"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Payment to discount"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "1170"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Payment to feedback submission"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "542"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Payment to invoice"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "395"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Payment to line item"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "524"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Payment to order"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "476"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Payment to payment link"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "397"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Payment to quote"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "393"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Payment to subscription"
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Quote to object"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "TYPE ID"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Association type"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "69"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Quote to contact"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "71"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Quote to company"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "64"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Quote to deal"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "67"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Quote to line item"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "286"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Quote to quote template"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "362"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Quote to discount"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "364"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Quote to fee"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "366"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Quote to tax"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "702"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact signer (for e-signatures)"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "733"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Quote to cart"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "408"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Quote to invoice"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "731"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Quote to order"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "398"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Quote to payment"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "304"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Quote to subscription"
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Line item to object"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "TYPE ID"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Association type"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "571"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Line item to abandoned cart"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "591"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Line item to cart"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "396"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Line item to commerce payment"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "20"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Line item to deal"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "368"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Line item to discount"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "410"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Line item to invoice"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "514"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Line item to order"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "759"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Line item to payment link"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "68"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Line item to quote"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "302"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Line item to subscription"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "565"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Upcoming line item to subscription"
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Order to object"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "TYPE ID"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Association type"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "593"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Order to cart"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "507"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Order to contact"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "509"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Order to company"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "512"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Order to deal"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "519"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Order to discount"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "521"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Order to discount code"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "518"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Order to invoice"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "513"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Order to line item"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "523"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Order to payment"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "730"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Order to quote"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "516"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Order to subscription"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "726"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Order to task"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "525"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Order to ticket"
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Cart to object"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "TYPE ID"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Association type"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "586"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Cart to contact"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "588"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Cart to discount"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "590"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Cart to line item"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "592"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Cart to order"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "732"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Cart to quote"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "728"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Cart to task"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "594"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Cart to ticket"
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "v1 associations (legacy)"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "If you're using the v1 associations API, view the table below for information about IDs to use when associating records."
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "Association type"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "ID"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact to company"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "1"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to contact (default)"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "2"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to contact (all labels)"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "280"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to contact"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "3"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact to deal"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "4"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to company"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "5"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to deal"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "6"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to engagement"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "7"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: "Engagement to company"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "8"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact to engagement"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "9"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: "Engagement to contact"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "10"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to engagement"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "11"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: "Engagement to deal"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "12"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: "Parent company to child company"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "13"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: "Child company to parent company"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "14"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: "Contact to ticket"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "15"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: "Ticket to contact"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "16"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: "Ticket to engagement"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "17"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: "Engagement to ticket"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "18"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to line item"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "19"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: "Line item to deal"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "20"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: "Company to ticket"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "25"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: "Ticket to company"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "26"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: "Deal to ticket"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "27"
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: "Ticket to deal"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "28"
          })]
        })]
      })]
    })]
  });
}
function MDXContent(props = {}) {
  const {
    wrapper: MDXLayout
  } = Object.assign({}, (0, _react.useMDXComponents)(), props.components);
  return MDXLayout ? (0, _jsxRuntime.jsx)(MDXLayout, Object.assign({}, props, {
    children: (0, _jsxRuntime.jsx)(_createMdxContent, props)
  })) : _createMdxContent(props);
}
var _default = exports.default = MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}